// Admin dashboard types. Kept separate from the user-facing client app on purpose.

export interface AdminAuthResponse {
    isLoggedIn: boolean
    isAdmin: boolean
    userName?: string
    avatarUrl?: string
}

export interface GetUsersResponse {
    users: AdminUser[]
    servers: AdminServer[]
}

export interface AdminUser {
    id: string
    name: string
    email: string
    steamId?: string
    discordId?: string
    subscriptionTier: number
    subscriptionNextUpdateTime: number
    created: number
}

export interface AdminServer {
    id: string
    owner: string
    displayName: string
    users: string[]
    tier: number
    mode: number
    isDisabled: boolean
    consoleMessageCount: number
    playerCount: number
}

// Mirrors the backend Data.Server.RconMode enum.
export enum RconMode {
    Rcon = 0,
    PluginRcon = 1,
}

export function rconModeLabel(mode: number): string {
    switch (mode) {
        case RconMode.Rcon:
            return "RCON"
        case RconMode.PluginRcon:
            return "Plugin RCON"
        default:
            return `Mode ${mode}`
    }
}

// Mirrors the backend Lib.Subscriptions.SubscriptionTier enum.
export enum SubscriptionTier {
    FREE = 0,
    T1 = 1,
    T2 = 2,
    T3 = 3,
    DEVELOPER = 1000,
}

// Plan names must match the marketing plans in src/pricing.ts (mapped by productId -> SubscriptionTier).
export const SUBSCRIPTION_TIER_OPTIONS: { value: SubscriptionTier; label: string }[] = [
    { value: SubscriptionTier.FREE, label: "Free" },
    { value: SubscriptionTier.T1, label: "Personal (T1)" },
    { value: SubscriptionTier.T2, label: "Team (T2)" },
    { value: SubscriptionTier.T3, label: "Organization (T3)" },
    { value: SubscriptionTier.DEVELOPER, label: "Developer" },
]

export function subscriptionTierLabel(tier: number): string {
    return SUBSCRIPTION_TIER_OPTIONS.find(o => o.value === tier)?.label ?? `Tier ${tier}`
}
